var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 53,
    viewBox: "0 0 102 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 51C2 44.5652 3.26742 38.1935 5.7299 32.2485C8.19239 26.3036 11.8017 20.9018 16.3518 16.3518C20.9018 11.8017 26.3036 8.19239 32.2485 5.7299C38.1935 3.26742 44.5652 2 51 2C57.4348 2 63.8065 3.26742 69.7515 5.7299C75.6964 8.19239 81.0982 11.8017 85.6482 16.3518C90.1983 20.9018 93.8076 26.3036 96.2701 32.2485C98.7326 38.1935 100 44.5652 100 51",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7168 44.0375L19.1501 46.9166M15.0668 23.8838L25.6835 29.642M31.4001 9.48837L37.9335 18.8454M51.0001 4.44995V16.6861M70.6001 9.48837L64.0668 18.8454M86.9335 23.8838L76.3168 29.642M94.2835 44.0375L82.8501 46.9166",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8169 42.8334L59.9836 15.4751",
    stroke: "#FF6000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8169 37.6167C54.6979 37.6168 57.0337 39.9525 57.0337 42.8335C57.0336 45.7145 54.6979 48.0502 51.8169 48.0503C48.9359 48.0503 46.6002 45.7145 46.6001 42.8335C46.6001 39.9524 48.9358 37.6167 51.8169 37.6167Z",
    fill: "#FF6000",
    stroke: "#FF6000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature3);
export default __webpack_public_path__ + "static/media/feature3.8e3ffa10f11af009d4bd91fd097dae99.svg";
export { ForwardRef as ReactComponent };